import React, { useState } from 'react'
import './qualification.css'
import { useInView } from 'react-intersection-observer'
import { useEffect } from 'react'



function Qualification() {
    const [toggleState, setToggleState] = useState(1)

    const toggleTab = (index) => {
        setToggleState(index)
    }

    const { ref , inView } = useInView({threshold : 0.3});

    useEffect(()=>{

        if(inView){
            document.querySelector(".qualification__section__title").style.transform = "translateY(0px)"
            document.querySelector(".qualification__section__title").style.opacity = 1
            document.querySelector(".qualification__section__subtitle").style.transform = "translateY(0px)"
            document.querySelector(".qualification__section__subtitle").style.opacity = 1
            document.querySelector(".qualification__button__left").style.transform = "translateX(0px)"
            document.querySelector(".qualification__button__left").style.opacity = 1
            document.querySelector(".qualification__button__right").style.transform = "translateX(0px)"
            document.querySelector(".qualification__button__right").style.opacity = 1


            document.querySelectorAll(".qualification__line").forEach((item)=>{
                item.style.height = "100%"
            })
            document.querySelectorAll(".qualification__rounder").forEach((item)=>{
                item.style.transform = "scale(1)"
            })
            document.querySelectorAll(".qualification__data").forEach((item)=>{
                item.style.transform = "scale(1)"
            })
        }
        else {
            document.querySelector(".qualification__section__title").style.transform = "translateY(100px)"
            document.querySelector(".qualification__section__title").style.opacity = 0
            document.querySelector(".qualification__section__subtitle").style.transform = "translateY(100px)"
            document.querySelector(".qualification__section__subtitle").style.opacity = 0
            document.querySelector(".qualification__button__left").style.transform = "translateX(-100px)"
            document.querySelector(".qualification__button__left").style.opacity = 0
            document.querySelector(".qualification__button__right").style.transform = "translateX(100px)"
            document.querySelector(".qualification__button__right").style.opacity = 0
            document.querySelectorAll(".qualification__line").forEach((item)=>{
                item.style.height = "0%"
            })
            document.querySelectorAll(".qualification__rounder").forEach((item)=>{
                item.style.transform = "scale(0)"
            })
            document.querySelectorAll(".qualification__data").forEach((item)=>{
                item.style.transform = "scale(0)"
            })
        }


    },[inView])


    return (
        <section className="qualification section">
            <h2 ref={ref}  className="section__title qualification__section__title">
                Qualification
            </h2>
            <span ref={ref} className="section__subtitle qualification__section__subtitle">My Personal Journey</span>


            <div className="qualification__container container">
                <div className="qualification__tabs">
                    <div ref={ref} className={toggleState === 1 ? "qualification__button qualification__active button--flex qualification__button__left" : "qualification__button button--flex qualification__button__left"} onClick={() => toggleTab(1)}>
                        <i className="uil uil-graduation-cap qualification__icon"></i>Education
                    </div>

                    <div ref={ref} className={toggleState === 2 ? "qualification__button qualification__active button--flex qualification__button__right" : "qualification__button button--flex qualification__button__right"} onClick={() => toggleTab(2)}>
                        <i className="uil uil-briefcase-alt qualification__icon"></i>
                        Experience
                    </div>
                </div>
                <div  className="qualification__sections">
                    <div ref={ref} className={ toggleState === 1 ? "qualification__content qualification__content-active" :"qualification__content"}>
                        <div className="qualification__data">
                            <div>
                                <h3 className="qualification__title">BCA </h3>
                                <span className="qualification__subtitle">Integral university</span>
                                <div className="qualification__calender">
                                    <i className="uil uil-calendar-alt"></i> 2020 - present
                                </div>
                            </div>

                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line" style={{"transitionDelay" : "0.1s"}}></span>
                            </div>
                        </div>


                        <div className="qualification__data" style={{"transitionDelay" : "0.35s"}}>

                            <div></div>

                            <div>
                                <span className="qualification__rounder" style={{"transitionDelay" : "0.35s"}}></span>
                                <span className="qualification__line" style={{"transitionDelay" : "0.4s"}}></span>
                            </div>
                            <div>
                                <h3 className="qualification__title">Intermediate</h3>
                                <span className="qualification__subtitle">Amrit Public School</span>
                                <div className="qualification__calender">
                                    <i className="uil uil-calendar-alt"></i> 2020
                                </div>
                            </div>


                        </div>


                        <div className="qualification__data" style={{"transitionDelay" : "0.75s"}}>
                            <div>
                                <h3 className="qualification__title">High School </h3>
                                <span className="qualification__subtitle">Fatima school</span>
                                <div className="qualification__calender">
                                    <i className="uil uil-calendar-alt"></i> 2018
                                </div>
                            </div>

                            <div>
                                <span className="qualification__rounder" style={{"transitionDelay" : "0.75s"}}></span>
                                <span className="qualification__line" style={{"transitionDelay" : "0.8s"}}></span>
                            </div>
                        </div>


                      

                    </div>

                    <div className={ toggleState === 2 ? "qualification__content qualification__content-active" :"qualification__content"}>
                        <div className="qualification__data">
                            <div>
                                <h3 className="qualification__title"> Freelancer</h3>
                                <span className="qualification__subtitle">Web development</span>
                                <div className="qualification__calender"> 
                                    <i className="uil uil-calendar-alt"></i> October 2022 - present
                                </div>
                            </div>

                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                        </div>


                        <div className="qualification__data">

                            <div></div>

                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                            <div>
                                <h3 className="qualification__title">Celebrare</h3>
                                <span className="qualification__subtitle">Frontend web developer</span>
                                <div className="qualification__calender">
                                    <i className="uil uil-calendar-alt"></i> April 2022 - September 2022
                                </div>
                            </div>


                        </div>


               


                     

                    </div>
                </div>
            </div>


        </section>
    )
}

export default Qualification